import PropTypes from 'prop-types';
import './Table.css';

export default function Table({
    columns,
    data = [],
    loading = false,
    emptyText = 'No data available',
    onRowClick,
    rowKey = 'id',
    className = ''
}) {
    return (
        <div className={`table-container ${className}`}>
            <table className="table">
                <thead>
                    <tr>
                        {columns.map((col) => (
                            <th
                                key={col.key}
                                style={{ width: col.width, textAlign: col.align || 'left' }}
                            >
                                {col.title}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan={columns.length} className="table-loading">
                                <div className="loading-spinner" />
                                <span>Loading...</span>
                            </td>
                        </tr>
                    ) : data.length === 0 ? (
                        <tr>
                            <td colSpan={columns.length} className="table-empty">
                                {emptyText}
                            </td>
                        </tr>
                    ) : (
                        data.map((row, rowIndex) => (
                            <tr
                                key={row[rowKey] || rowIndex}
                                onClick={() => onRowClick?.(row)}
                                className={onRowClick ? 'clickable' : ''}
                            >
                                {columns.map((col) => (
                                    <td
                                        key={col.key}
                                        style={{ textAlign: col.align || 'left' }}
                                    >
                                        {col.render
                                            ? col.render(row[col.dataIndex], row, rowIndex)
                                            : row[col.dataIndex]}
                                    </td>
                                ))}
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
}

Table.propTypes = {
    columns: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        dataIndex: PropTypes.string,
        width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        align: PropTypes.oneOf(['left', 'center', 'right']),
        render: PropTypes.func
    })).isRequired,
    data: PropTypes.array,
    loading: PropTypes.bool,
    emptyText: PropTypes.string,
    onRowClick: PropTypes.func,
    rowKey: PropTypes.string,
    className: PropTypes.string
};
